import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { compose } from "redux";
import AwesomeIcon from "@icons/AwesomeIcon";
import * as actions from "@/redux/actions";
import { RootState } from "@/types/RootState";
import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";
import "./backhistory.css";

interface BackHistoryProps extends RouteComponentProps {
  global: {
    historyCount: number;
    isMobile: boolean;
    showAiChat?: boolean;
    showNotification?: boolean;
    menuType?: "MAIN" | "ADMIN";
    dashboardNotification?: unknown;
    preventSidebar?: boolean;
    newNotificationsCount?: number;
    reloadSidebar?: boolean;
    logoPath?: string;
    showCanvasMenu?: boolean;
  };
  backHistory: () => void;
}

const BackHistory = ({ global, history, backHistory }: BackHistoryProps) => {

  const backClicked = (ev?: React.MouseEvent<HTMLAnchorElement>, backDefault?: string) => {
    ev?.preventDefault();

    if (global.historyCount > 0) {
      backHistory();
      history.goBack();
    } else {
      window.location.href = backDefault || "";
    }
  };

  if (global.historyCount <= 0) return null;

  return (
    <span className="leftBreakcrumb">
      <a
        href="# "
        onClick={(ev) => backClicked(ev)}
        title={translate(LanguageKey.back_overview_key)}
        className="me-2"
      >
        <AwesomeIcon
          className="back-history"
          icon="arrow-left"
          size="xl"
        ></AwesomeIcon>
      </a>
    </span>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    global: state.all,
  };
};
const mapDispatchToProps = (dispatch: (action: ReturnType<typeof actions.backHistory>) => void) => {
  return {
    backHistory: () => {
      dispatch(actions.backHistory());
    },
  };
};

export default compose<React.ComponentType>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BackHistory) as React.ComponentType;
